module.exports = __webpack_public_path__ + "static/media/wwa.26022ddc.png";